export async function updateOrganization(name: string) {
  try {
    const response = await fetch("/api/organization", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name }),
    });

    if (!response.ok) {
      throw new Error("Failed to update organization");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("[updateOrganization] Failed to update organization:", {
      error: error instanceof Error ? error.message : "Unknown error",
    });
    throw error;
  }
}
